import { ContactApi, FeatureFlag, FeatureFlagApi } from '@services/generated';
import api from 'services/api';
import { handleErrors } from 'services/helpers';
import { rootApi } from 'store/root-api';
import appUrls from 'utils/app-urls';

const API_URL = appUrls.getEndpointUrl();

const featureFlagsClient = new FeatureFlagApi(
  undefined,
  new URL(API_URL, process.env.REACT_API_URL).href,
  api,
);

export const featureFlagsApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getFeatureFlags: builder.query<FeatureFlag[], void>({
      queryFn: () => handleErrors(() => featureFlagsClient.list()),
      providesTags: [{ type: 'FeatureFlags' }],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetFeatureFlagsQuery } = featureFlagsApi;
